// /* eslint-disable no-unused-vars */
// import React, { useState, useContext } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { message, Spin } from "antd";
// import UserContext from "../Context/UserContext";
// import { FaEye, FaEyeSlash } from "react-icons/fa";
// import { useDispatch } from "react-redux";
// import { setUserInfo } from "../../features/auth/authSlice";


// const Login = () => {
//   const [loginData, setLoginData] = useState({
//     email: "",
//     password: "",
//   });
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const { setUser } = useContext(UserContext);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const handleChange = (event) => {
//     const { name, value } = event.target;
//     setLoginData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!loginData.email || !loginData.password) {
//       message.error("All fields are required");
//       return;
//     }

//     if (/\s/.test(loginData.email)) {
//       message.error("Email should not contain spaces");
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await axios.post(`${API_BASE}/user/login`, {
//         email: loginData.email,
//         password: loginData.password,
//       });
//       setLoading(false);
//       console.log("response.data.data.user.role", response.data.data.user.role);
//       if (response.data.data.user.action === true) {
//         console.log("true");
//         navigate("/");
//         message.error("you are blocked by admin");
//       }
//        else {
//         if (response.data.statusCode === 200) {
//           const { accessToken, refreshToken, user } = response.data.data;
//           console.log("accessToken", accessToken);
//           // Cookies.set('accessToken', accessToken, { path: '/' });
//           localStorage.setItem(
//             "auth",
//             JSON.stringify({ accessToken, refreshToken, user })
//           );

//           setUser(user);
//           dispatch(setUserInfo(response.data));
//           if (response.data.data.user.role === "admin") {
//             navigate("/admin");
//           }
//           if (response.data.data.user.role === "user") {
//             navigate("/FilteredBook");
//           }if (response.data.data.user.role === "provider") {
//             navigate("/");
//           }
//           // navigate(response.data.data.user.role === 'admin' ? '/admin' : '/');
//           // navigate(response.data.data.user.role === "user" ? "/book" : "/")
//         } else {
//           message.error(response.data.message);
//         }
//       }
//     } catch (error) {
//       setLoading(false);
//       console.error("Error during login:", error);
//       message.error("Invalid Credentials");
//     }
//   };
// const API_BASE = process.env.REACT_APP_API_BASE;

//   return (
//      <div
//       className='min-h-screen bg-cover bg-center flex items-center justify-center px-4'
//       style={{
//         backgroundImage: "url('https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80')",
//       }}
//     >
//       <div className='w-full max-w-md p-6 bg-white bg-opacity-90 rounded-lg shadow-lg'>
//         <h2 className='text-center text-2xl font-semibold mb-6 text-gray-800'>Sign In</h2>
//         <form onSubmit={handleSubmit}>
//           <div className='mb-4'>
//             <label className='block text-gray-700'>Email</label>
//             <input
//               type='email'
//               name='email'
//               value={loginData.email}
//               onChange={handleChange}
//               className='w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500'
//               placeholder='Enter your email'
//               required
//             />
//           </div>
//           <div className='mb-4 relative'>
//             <label className='block text-gray-700'>Password</label>
//             <input
//               type={showPassword ? 'text' : 'password'}
//               name='password'
//               value={loginData.password}
//               onChange={handleChange}
//               className='w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-red-500'
//               placeholder='Enter your password'
//               required
//             />
//             <button
//               type='button'
//               onClick={togglePasswordVisibility}
//               className='absolute inset-y-0 right-3 top-8 text-gray-500'
//             >
//               {showPassword ? <FaEyeSlash /> : <FaEye />}
//             </button>
//           </div>
//           <button
//             type='submit'
//             className='w-full py-2 bg-red-500 text-white rounded-md hover:bg-red-600'
//           >
//             {loading ? <Spin /> : 'Sign In'}
//           </button>
//         </form>
//         <div className='flex justify-between mt-4'>
//           <Link to='/register' className='text-red-500 hover:underline'>
//             Sign Up
//           </Link>
//           <Link to='/forgetpassword' className='text-red-500 hover:underline'>
//             Forget Password
//           </Link>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;
/* eslint-disable no-unused-vars */

import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { message } from "antd"; // Retaining Antd message for popups

// 🚨 FIX: Mocking UserContext to make the component self-contained.
const UserContext = React.createContext({
  user: null,
  setUser: () => {},
});

// Global constant (assuming this is how it's defined in your environment)
const API_BASE = process.env.REACT_APP_API_BASE;

// ------------------- NEW LOADER COMPONENT (Same as Register) -------------------

const FullScreenLoader = () => (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-green-700 bg-opacity-90">
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-white mb-4"></div>
        <p className="text-white text-xl font-semibold">Authenticating...</p>
      </div>
    </div>
);

// ------------------- Reusable Input Field -------------------

const InputField = ({ label, name, type = "text", value, onChange, disabled, placeholder }) => (
  <div>
    <label className="block text-gray-700 text-sm mb-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 disabled:bg-gray-100"
      placeholder={placeholder}
      required
    />
  </div>
);

// ------------------- Reusable Password Field (Using Inline SVG) -------------------

const EyeIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" {...props}>
    <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
    <path fillRule="evenodd" d="M1.323 11.487L.5 12l.823.513 9.875 6.172a3 3 0 002.606 0l9.875-6.172-.823-.513-9.875-6.172a3 3 0 00-2.606 0l-9.875 6.172zM12 9a3 3 0 100 6 3 3 0 000-6z" clipRule="evenodd" />
  </svg>
);

const EyeSlashIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5" {...props}>
    <path d="M12.001 5.75c3.555 0 6.843 1.554 9.123 4.144a.75.75 0 010 1.109C18.844 14.717 15.555 16.272 12 16.272c-1.396 0-2.731-.296-3.955-.838l3.184-3.184A3 3 0 0012 12c.002-.27-.053-.53-.146-.777l-.613-.613 2.502-2.502a12.872 12.872 0 013.882 1.696.75.75 0 00.999-1.127A14.288 14.288 0 0012.001 4.25a.75.75 0 000 1.5z" />
    <path d="M22.84 21.08a.75.75 0 001.077 1.058l-1.077-1.058zM17.072 16.634l-3.235-3.235A3.01 3.01 0 0012 11.75a3.01 3.01 0 00-3.003 3.022.75.75 0 001.5.023A1.5 1.5 0 0112 13.25c.484 0 .937.198 1.258.534l3.235 3.235a13.31 13.31 0 01-3.418 1.545.75.75 0 10-.361 1.458 14.815 14.815 0 004.288-1.895l1.621 1.621a.75.75 0 001.06-.02z" />
    <path fillRule="evenodd" d="M18.91 19.82a.75.75 0 00-.001-.001L4.17 5.17A.75.75 0 105.17 4.17L19.83 18.83a.75.75 0 00.001 1.07zm-11.896-.705l-4.577-4.578a.75.75 0 00-.001-.001L1.25 12l.718-.448 4.578 4.578a.75.75 0 00.705.001z" clipRule="evenodd" />
  </svg>
);


const PasswordField = ({ label, name, value, onChange, showPassword, togglePasswordVisibility, disabled }) => (
  <div className="relative">
    <label className="block text-gray-700 text-sm mb-1">{label}</label>
    <input
      type={showPassword ? "text" : "password"}
      name={name}
      value={value}
      onChange={onChange}
      disabled={disabled}
      placeholder="Enter your password"
      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-green-500 focus:border-green-500 pr-10 disabled:bg-gray-100"
      required
    />
    <button
      type="button"
      onClick={togglePasswordVisibility}
      className="absolute right-3 top-0 mt-8 text-gray-600 hover:text-green-700 disabled:opacity-50"
      disabled={disabled}
    >
      {showPassword ? <EyeSlashIcon /> : <EyeIcon />} {/* 🚨 FIX: Using inline SVG components */}
    </button>
  </div>
);


const Login = () => {
  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false); // Used for both form disabling and loader display

  // 🚨 FIX: Removed `useDispatch` and `dispatch(setUserInfo(...))` calls since Redux is unavailable.
  // The UserContext usage is kept, but it uses the mocked context defined above.
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  // const dispatch = useDispatch(); // Removed

  const handleChange = (event) => {
    const { name, value } = event.target;
    setLoginData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!loginData.email || !loginData.password) {
      message.error("All fields are required");
      return;
    }

    if (/\s/.test(loginData.email)) {
      message.error("Email should not contain spaces");
      return;
    }

    // 🚨 START LOADING
    setLoading(true);

    try {
      const response = await axios.post(`${API_BASE}/user/login`, {
        email: loginData.email,
        password: loginData.password,
      });

      console.log("response.data.data.user.role", response.data.data.user.role);
      
      const userAction = response.data.data.user.action;
      const userRole = response.data.data.user.role;
      const statusCode = response.data.statusCode;

      if (userAction === true) {
        // console.log("true"); // original code had this, keeping it for reference
        message.error("You are blocked by admin");
        navigate("/"); // Navigate away after error
      } else {
        if (statusCode === 200) {
          const { accessToken, refreshToken, user } = response.data.data;
          // console.log("accessToken", accessToken); // original code had this

          localStorage.setItem(
            "auth",
            JSON.stringify({ accessToken, refreshToken, user })
          );

          setUser(user);
          // dispatch(setUserInfo(response.data)); // Removed

          if (userRole === "admin") {
            navigate("/admin");
          } else if (userRole === "user") {
            navigate("/FilteredBook");
          } else if (userRole === "provider") {
            navigate("/");
          }
        } else {
          message.error(response.data.message);
        }
      }
    } catch (error) {
      console.error("Error during login:", error);
      message.error("Invalid Credentials");
    } finally {
      // 🚨 STOP LOADING REGARDLESS OF SUCCESS/FAILURE
      setLoading(false);
    }
  };

  return (
    <>
      {/* 🚨 Conditional Full-Screen Loader */}
      {loading && <FullScreenLoader />} 

      <div
        className='min-h-screen bg-cover bg-center flex items-center justify-center px-4'
        style={{
          // Keeping the original background image
          backgroundImage: "url('https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1350&q=80')",
        }}
      >
        <div className='w-full max-w-md p-8 bg-white bg-opacity-95 rounded-lg shadow-2xl border border-gray-200'>
          
          {/* MF Blind-style Header */}
          <div className="mb-6 border-b pb-4">
            <h1 className="text-xl font-bold text-green-700">MF Blind</h1>
            <p className="text-sm text-green-700">Service Provider Network</p>
          </div>
          <h2 className='text-center text-2xl font-bold mb-6 text-gray-800'>Welcome Back!</h2>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            
            {/* Email Field (Using MF Blind InputField component) */}
            <InputField
              label="Email"
              name="email"
              type="email"
              value={loginData.email}
              onChange={handleChange}
              placeholder='Enter your email'
              disabled={loading}
            />

            {/* Password Field (Using MF Blind PasswordField component) */}
            <PasswordField
              label="Password"
              name="password"
              value={loginData.password}
              onChange={handleChange}
              showPassword={showPassword}
              togglePasswordVisibility={togglePasswordVisibility}
              disabled={loading}
            />
            
            {/* Submit Button (MF Blind Green Style) */}
            <button
              type='submit'
              className='w-full py-3 bg-green-700 text-white rounded-md font-semibold hover:bg-green-800 transition duration-150 shadow-md disabled:opacity-50'
              disabled={loading} // 🚨 Disable button while loading
            >
              {loading ? 'Authenticating...' : 'Sign In'}
            </button>
          </form>

          {/* Links Section */}
          <div className='flex justify-between mt-6 text-sm'>
            <Link 
              to='/register' 
              className={`text-green-700 hover:text-green-900 font-medium ${loading ? 'pointer-events-none opacity-60' : ''}`}
            >
              <span className="border-b border-green-700 border-opacity-50 pb-0.5">
                Create Account (Sign Up)
              </span>
            </Link>
            <Link 
              to='/forgetpassword' 
              className={`text-green-700 hover:text-green-900 font-medium ${loading ? 'pointer-events-none opacity-60' : ''}`}
            >
              <span className="border-b border-green-700 border-opacity-50 pb-0.5">
                Forget Password?
              </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;